<div class="dialog-container">
  <button type="button" class="dialog-close" (click)="cancel()" aria-label="Close">
    <span inlineSVG="/icons/icon-close.svg"></span>
  </button>

  <h2 class="dialog-header">{{ 'global.code_import.title' | transloco }}</h2>
  <p class="dialog-subtitle">
    <span class="file-name">{{ data.file.name }}</span>
    <span class="file-size">{{ fileSizeLabel }}</span>
  </p>

  @if (loading) {
    <div class="reading">
      <mat-spinner [diameter]="20"></mat-spinner>
      <span>{{ 'global.code_import.reading' | transloco }}</span>
    </div>
  }

  @if (error) {
    <p class="import-error">{{ error | transloco }}</p>
  }

  @if (!loading && !error) {
    <mat-checkbox class="checkbox" [checked]="hasHeader" (change)="onHasHeaderChange($event.checked)">
      {{ 'global.code_import.has_header' | transloco }}
    </mat-checkbox>
    <div class="options-row">
      <!-- A spreadsheet arrives already split into cells, so neither applies to one. -->
      @if (!isSheet) {
        <div class="form-field-container">
          <div class="form-field-label">
            <span>{{ 'global.code_import.separator' | transloco }}</span>
          </div>
          <lib-select
            [options]="separatorOptions"
            [translation]="true"
            [value]="separator"
            [truncateValue]="true"
            (valueChange)="onSeparatorChange($event)"
          ></lib-select>
        </div>
      }
      @if (showEncoding) {
        <div class="form-field-container">
          <div class="form-field-label">
            <span>{{ 'global.code_import.encoding' | transloco }}</span>
          </div>
          <lib-select
            [options]="encodingOptions"
            [translation]="true"
            [value]="encoding"
            [truncateValue]="true"
            (valueChange)="onEncodingChange($event)"
          ></lib-select>
        </div>
      }
      <div class="form-field-container">
        <div class="form-field-label">
          <span>{{ 'global.code_import.code_column' | transloco }}</span>
        </div>
        <lib-select
          [options]="columnOptions"
          [translation]="false"
          [value]="columnIndex"
          [truncateValue]="true"
          (valueChange)="onColumnChange($event)"
        ></lib-select>
      </div>
    </div>
    <!-- The preview reads the file the way the server will, so a wrong separator or column shows up
    here rather than as a batch full of skipped rows. -->
    @if (dataRows.length) {
      <div class="preview">
        <table class="preview__table">
          <thead>
            <tr>
              @for (column of columnOptions; track column) {
                <th [class.is-selected]="column.value === columnIndex">
                  {{ column.key }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of previewRows; track row) {
              <tr>
                @for (column of columnOptions; track column) {
                  <td [class.is-selected]="column.value === columnIndex">
                    {{ row[column.value] }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
        @if (hiddenRowCount) {
          <p class="preview__more">
            {{ 'global.code_import.more_rows' | transloco: { count: hiddenRowCount } }}
          </p>
        }
        @if (truncated) {
          <p class="preview__more">
            {{ 'global.code_import.preview_truncated' | transloco }}
          </p>
        }
      </div>
    } @else {
      <p class="import-error">{{ 'global.code_import.error_no_rows' | transloco }}</p>
    }
  }

  <div class="dialog-actions">
    <button type="button" class="btn btn-secondary" (click)="cancel()">
      {{ 'global.cancel' | transloco }}
    </button>
    <button type="button" class="btn btn-primary" [disabled]="!canImport" (click)="submit()">
      {{
        truncated || error
          ? ('global.code_import.import' | transloco)
          : ('global.code_import.import_count' | transloco: { count: importableRowCount })
      }}
    </button>
  </div>
</div>
